<template>
    <div id="Dify">

    </div>
</template>
<script>
window.difyChatbotConfig = {
    token: '2qzW8zIsT9WYXScp',
    baseUrl: 'http://117.156.83.63:50009'
}
</script>
<script
 src="http://117.156.83.63:50009/embed.min.js"
 id="2qzW8zIsT9WYXScp"
 defer>
</script>
<script>
export default {
  name: "Dify",
  methods: {

  }
};
</script>
<style>
#dify-chatbot-bubble-button {
    background-color: #1c64f2 !important;
}
#dify-chatbot-bubble-window {
    width: 24rem !important;
    height: 40rem !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dify.vue